import { useState } from 'react'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import walletService from '../services/walletService'
import useModalEnter from '../hooks/useModalEnter'

// Owner Add Balance — header dropdown, SIRF owner (Layout isOwner() se dikhata hai,
// server requireOwner se gate karta hai). Owner apne hi wallet me balance daalta hai:
// POST /admin/wallet/owner/add-balance → inr + credit + all_point + point ledger entry.
// Same shell as ChangePasswordModal. Modal sirf success pe band hota hai.
function OwnerAddBalanceModal({ onClose, onSuccess }) {
  const user = useSelector((state) => state.auth.user)
  const [formData, setFormData] = useState({ amount: '', remark: '', transactionPassword: '' })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState({})

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
  })

  // Server wala hi rule: sirf plain number (100, 100.50), 0 se bada
  const validateAll = (data) => {
    const next = {}
    const amt = String(data.amount).trim()
    if (!amt) next.amount = 'The Amount field is required'
    else if (!/^\d+(\.\d+)?$/.test(amt) || Number(amt) <= 0) next.amount = 'Enter valid amount'
    if (String(data.remark).trim().length > 200) next.remark = 'Remark max 200 characters allowed'
    if (!data.transactionPassword) next.transactionPassword = 'The Transaction Code field is required'
    return next
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    if (errors[name]) setErrors((prev) => { const out = { ...prev }; delete out[name]; return out })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    // Request chal rahi ho to dusra submit nahi — double click = double balance
    if (isSubmitting) return

    const found = validateAll(formData)
    setErrors(found)
    if (Object.keys(found).length) return

    setIsSubmitting(true)
    try {
      const response = await walletService.addOwnerBalance({
        amount: String(formData.amount).trim(),
        remark: String(formData.remark).trim(),
        transactionPassword: formData.transactionPassword,
      })

      if (response?.success) {
        Toast.fire({ icon: 'success', title: response?.message || 'Balance added successfully' })
        onSuccess?.(response.data)
        onClose()
      } else {
        Toast.fire({ icon: 'error', title: response?.message || 'Failed to add balance' })
      }
    } catch (error) {
      Toast.fire({ icon: 'error', title: error?.response?.data?.message || 'Failed to add balance' })
    } finally {
      setIsSubmitting(false)
    }
  }

  const { modalClass, backdropClass, onBackdropClick } = useModalEnter(onClose)

  return (
    <div style={{ position: 'absolute', zIndex: 1040 }}>
      <div role="dialog" className={modalClass} aria-modal="true" style={{ display: 'block' }} onClick={onBackdropClick}>
        <div className="modal-dialog modal-md">
          <span tabIndex="0"></span>
          <div tabIndex="-1" className="modal-content">
            <header className="modal-header bg-default">
              <h5 className="modal-title text-uppercase">Add Balance</h5>
              <button type="button" data-dismiss="modal" className="close" onClick={onClose}>&times;</button>
            </header>
            <div className="modal-body">
              <form method="post" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Current Balance</label>
                  <input type="text" className="form-control" value={Number(user?.inr_balance ?? 0).toLocaleString()} readOnly disabled />
                </div>
                <div className="form-group">
                  <input placeholder="Amount" type="text" inputMode="decimal" name="amount" className={`form-control${errors.amount ? ' is-invalid' : ''}`} value={formData.amount} onChange={handleChange} disabled={isSubmitting} />
                  {errors.amount && <small className="error">{errors.amount}</small>}
                </div>
                <div className="form-group">
                  <input placeholder="Remark (optional)" type="text" name="remark" maxLength={200} className={`form-control${errors.remark ? ' is-invalid' : ''}`} value={formData.remark} onChange={handleChange} disabled={isSubmitting} />
                  {errors.remark && <small className="error">{errors.remark}</small>}
                </div>
                <div className="form-group">
                  <input placeholder="Transaction Code" type="password" name="transactionPassword" autoComplete="new-password" className={`form-control${errors.transactionPassword ? ' is-invalid' : ''}`} value={formData.transactionPassword} onChange={handleChange} disabled={isSubmitting} />
                  {errors.transactionPassword && <small className="error">{errors.transactionPassword}</small>}
                </div>
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
                    Add Balance
                    <i className="fas fa-chevron-circle-right ml-2"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <span tabIndex="0"></span>
        </div>
      </div>
      <div className={backdropClass}></div>
    </div>
  )
}

export default OwnerAddBalanceModal
